import NoneSpecialEffect from './definitions/NoneSpecialEffect';
import TimelineSpecialEffect from './definitions/TimelineSpecialEffect';
// Import other special effect definitions here

// Registry Map
export const SPECIAL_EFFECTS_REGISTRY = {
  [NoneSpecialEffect.id]: NoneSpecialEffect,
  [TimelineSpecialEffect.id]: TimelineSpecialEffect,
  // Add other effects here
};

// Default Special Effect ID
export const DEFAULT_SPECIAL_EFFECT_ID = 'none';

// Get all special effects as an array
export const getAllSpecialEffects = () => {
  return Object.values(SPECIAL_EFFECTS_REGISTRY);
};

// Get a specific special effect by ID
export const getSpecialEffectById = (id) => {
  return SPECIAL_EFFECTS_REGISTRY[id] || SPECIAL_EFFECTS_REGISTRY[DEFAULT_SPECIAL_EFFECT_ID]; // Fallback to default
};

// Export all functions and the registry itself (optional, based on usage)
// export default {
//   SPECIAL_EFFECTS_REGISTRY,
//   DEFAULT_SPECIAL_EFFECT_ID,
//   getAllSpecialEffects,
//   getSpecialEffectById,
// }; 